module.exports = {
  GET_HEATMAP: 'ott/search/getHeatmap',
  GET_HEATMAP_SUCCESS: 'ott/search/getHeatmapSuccess',
  GET_HEATMAP_FAIL: 'ott/search/getHeatmapFail',
};
